import * as React from "react";
const WidgetActionsContext = React.createContext(void 0);
export default WidgetActionsContext;
